import { createFileRoute } from "@tanstack/react-router";
import { PageHero } from "@/components/site/PageHero";
import { ArrowRight, Calendar } from "lucide-react";

export const Route = createFileRoute("/blogs")({
  head: () => ({
    meta: [
      { title: "Blog — Digital Marketing Insights | BigBrandBooster" },
      { name: "description", content: "Trends, frameworks and playbooks on SEO, paid media, content and growth from the BigBrandBooster team." },
      { property: "og:title", content: "Blog — BigBrandBooster" },
      { property: "og:description", content: "Trends, frameworks and playbooks on digital marketing." },
    ],
    links: [{ rel: "canonical", href: "/blogs" }],
  }),
  component: BlogsPage,
});

const posts = [
  { cat: "SEO", title: "The 2026 SEO Playbook: AI Overviews, E-E-A-T & topical authority", date: "May 12, 2026", read: "8 min" },
  { cat: "Paid Media", title: "Why incrementality testing is the new ROAS", date: "Apr 28, 2026", read: "6 min" },
  { cat: "Creative", title: "Performance creative: a system, not a campaign", date: "Apr 15, 2026", read: "5 min" },
  { cat: "Analytics", title: "Server-side tracking without losing your mind", date: "Mar 30, 2026", read: "7 min" },
  { cat: "Ecommerce", title: "Retention math: the LTV levers most brands ignore", date: "Mar 18, 2026", read: "9 min" },
  { cat: "Social", title: "Creator partnerships at scale — an operating model", date: "Mar 02, 2026", read: "6 min" },
];

const gradients = [
  "from-indigo-500 to-purple-600",
  "from-sky-500 to-cyan-500",
  "from-rose-500 to-orange-500",
  "from-emerald-500 to-teal-600",
  "from-amber-500 to-pink-600",
  "from-violet-500 to-fuchsia-600",
];

function BlogsPage() {
  return (
    <>
      <PageHero
        eyebrow="Insights"
        title={<>Field notes on <span className="text-accent">modern growth.</span></>}
        description="Playbooks, frameworks and trends straight from our practitioners."
      />

      <section className="container-page py-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((p, i) => (
            <article key={p.title} className="group rounded-3xl border border-border bg-card overflow-hidden hover:shadow-elegant transition">
              <div className={`aspect-[16/10] bg-gradient-to-br ${gradients[i % gradients.length]} relative`}>
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_30%,rgba(255,255,255,0.3),transparent_60%)]" />
                <span className="absolute top-4 left-4 rounded-full bg-white/20 backdrop-blur px-3 py-1 text-xs font-semibold uppercase tracking-widest text-white">{p.cat}</span>
              </div>
              <div className="p-6">
                <h3 className="font-display text-xl font-semibold text-ink leading-snug group-hover:text-primary transition">{p.title}</h3>
                <div className="mt-5 flex items-center justify-between text-xs text-muted-foreground">
                  <span className="inline-flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5" /> {p.date} · {p.read}</span>
                  <span className="inline-flex items-center gap-1 font-semibold text-primary">Read <ArrowRight className="h-3.5 w-3.5" /></span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
